import { render, staticRenderFns } from "./AppointmentsWidgets.vue?vue&type=template&id=19c7a94c&"
import script from "./AppointmentsWidgets.vue?vue&type=script&lang=js&"
export * from "./AppointmentsWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports